// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"292":"5b1e7abc","983":"b320c484"}[chunkId] + ".chunk.js";
};